export const BRANDS_TO_FETCH = [
  { query: "airbnb", name: "Airbnb" },
  { query: "cabela's", name: "Cabela's" },
  { query: "carnival", name: "Carnival" },
  { query: "fandango", name: "Fandango" },
  { query: "hotels.com", name: "Hotels.com" },
  { query: "lowe's", name: "Lowe's" },
  { query: "nutrisystem", name: "Nutrisystem" },
  { query: "southwest", name: "Southwest Airlines" },
  { query: "starbucks", name: "Starbucks Coffee" },
  { query: "target", name: "Target" },
  { query: "depot", name: "The Home Depot®" },
  { query: "walmart", name: "Walmart" }
];
